// initial slick carousel
$(function() {
    $('.fw-modal__media-carousel').slick({
        arrows: true,
        dots: false,
        prevArrow: `
        <button type="button" class="fw-modal-media-control fw-modal-media-prev">
        <svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 17.2307L2 9.61533L11 1.99994" stroke="#9FAEE5" stroke-width="2.07692" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </button>`,
        nextArrow: `
        <button type="button" class="fw-modal-media-control fw-modal-media-next">
            <svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2L11 9.61538L2 17.2308" stroke="#9FAEE5" stroke-width="2.07692" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>`
    });
    $('.fw-modal__media-carousel-wrap').addClass('initialized');
});

// ************************************************************
// Start Utility Functions
// ************************************************************

// utility functions:

function _handleModalOption(variant_id) {
    let $option = $(`.fw-modal-option[data-variant-id="${variant_id}"]`);

    let title = $option.attr('data-product-title');
    let description = $option.attr('data-product-description');
    let images = $option.attr('data-image-src').split('|');

    // update title + description + value props

    $('#fw-modal').find('.fw-modal-toggle-wrap h3').html(title);
    // TODO: description
    // TODO: value props

    // update images

    $('.fw-modal__media-carousel-wrap').removeClass('initialized');
    $('.fw-modal__media-carousel').slick('unslick');

    let newCarousel = '';

    images.forEach((image, index) => {
        newCarousel += `
        <div class="fw-modal__media-carousel-slide">
            <img src="${image}" alt="Forever Wear - ${title} image ${index + 1}"/>
        </div>
        `
    })

    $('.fw-modal__media-carousel').html(newCarousel);

    setTimeout(function() {
        $('.fw-modal__media-carousel').slick({
            arrows: true,
            dots: false,
            prevArrow: `
            <button type="button" class="fw-modal-media-control fw-modal-media-prev">
            <svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 17.2307L2 9.61533L11 1.99994" stroke="#9FAEE5" stroke-width="2.07692" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </button>`,
            nextArrow: `
            <button type="button" class="fw-modal-media-control fw-modal-media-next">
                <svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 2L11 9.61538L2 17.2308" stroke="#9FAEE5" stroke-width="2.07692" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>`
        });
        $('.fw-modal__media-carousel-wrap').addClass('initialized');
    }, 500);
}

// ************************************************************
// END Global FW Bundle Vars + Utility Functions
// ************************************************************

// modal listeners:

$('.fw-lp-swatches-container .fw-modal-options').on('click', '.fw-modal-option', function(event) {
    let $option = $(event.target).closest('.fw-modal-option');
    $('.fw-modal-option').removeClass('active');
    $option.addClass('active');

    let variant_id = $option.attr('data-variant-id');

    _handleModalOption(variant_id);
})

$('.fw-lp-swatches-container').on('click', '.fw-lp-swatch-mobile-toggle', function(event) {
    let $media = $(event.target).closest('.fw-modal__media');
    $media.addClass('expanded');
})

$('.fw-lp-swatches-container').on('click', '.fw-swatch-link', function(event) {
    let $active_swatch = $(event.target).closest('.fw-lp-swatches-container').find('.fw-modal-option.active');
    let product_url = $active_swatch.attr('data-product-url');
    window.location.href = product_url;
})
  